import React from 'react';
import { Section, FadeIn } from './ui/Section';
import { CheckCircle2, XCircle } from 'lucide-react';
export function TargetAudience() {
  return <Section background="white" data-id="element-206">
      <div className="grid md:grid-cols-2 gap-12" data-id="element-207">
        <FadeIn delay={0.1} data-id="element-208">
          <div data-id="element-209">
            <h3 className="text-2xl font-serif text-[#3D1F2E] mb-6 flex items-center" data-id="element-210">
              <CheckCircle2 className="w-6 h-6 text-[#28A745] mr-3" data-id="element-211" />
              Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-212">
              {['Compras por impulso (especialmente de noche)', 'Quieres control sin perder tu estilo de vida', 'Estás lista para seguir un sistema simple 14 días'].map((item, i) => <li key={i} className="flex items-start text-[#7A5C6B]" data-id="element-213">
                  <span className="mr-3 text-[#28A745]" data-id="element-214">•</span>
                  {item}
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-215">
          <div data-id="element-216">
            <h3 className="text-2xl font-serif text-[#3D1F2E] mb-6 flex items-center" data-id="element-217">
              <XCircle className="w-6 h-6 text-[#DC3545] mr-3" data-id="element-218" />
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-219">
              {['Buscas "hacer dinero rápido"', 'No estás dispuesta a poner fricción (aunque sea mínima)', 'Estás en una crisis severa que requiere apoyo profesional inmediato'].map((item, i) => <li key={i} className="flex items-start text-[#7A5C6B]" data-id="element-220">
                  <span className="mr-3 text-[#DC3545]" data-id="element-221">•</span>
                  {item}
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </Section>;
}